import { useMemo } from 'react';
import { PaymentMethod } from '../../../types/payment.types';
import { PaymentMethodType } from '@/modules/user/user.types';
import { AccountStatus } from '@common-fe/common-fe';
import { useGetBankAccountByIdQuery } from '../DirectDeposit/BankForm/useGetBankAccountsList.query';
import { BankFields } from '../DirectDeposit/BankForm/useBankFields';

export const usePaymentMethodHasPendingMessage = (paymentMethod?: Partial<PaymentMethod>, isRejectionFlow?: boolean) => {
  const isDirectDeposit = useMemo(() => paymentMethod?.type === PaymentMethodType.DIRECT_DEPOSIT, [paymentMethod]);
  const { currentBankAccount, isLoading } = useGetBankAccountByIdQuery(isDirectDeposit ? paymentMethod?.accountId : undefined);

  const hasAccountVerificationPendingMessage = useMemo(() => {
    const accountStatus = currentBankAccount?.[BankFields.accountStatus];
    const isAccountInPendingStatus = accountStatus && accountStatus === AccountStatus.PENDING;

    return isRejectionFlow ? isAccountInPendingStatus : isAccountInPendingStatus;
  }, [currentBankAccount, isRejectionFlow]);

  return { hasAccountVerificationPendingMessage, isLoading };
};
